import { message } from 'antd';
import { getLocale } from 'umi';
import request from 'umi-request';
import { encode } from './RequestUrlUtils';
import { Langs } from './LangUtil';
export function errorHandler(error) {
  const codeMap = {
    '021': '发生错误啦',
    // ....
  };

  if (error.response) {
    console.log(error.response.status);
    console.log(error.response.headers);
    console.log(error.data);
    console.log(error.request);
    console.log(codeMap[error.data.status]);
  } else {
    console.log(error.message);
  }

  throw error;
}

const controller = new AbortController();
const signal = controller.signal;
signal.addEventListener('abort', () => {
  console.log('aborted!');
});

export function iRequest(url, option) {
  let lang = Langs[getLocale()].serverCode;
  if (url.indexOf('?') > -1) {
    url = url + '&lang=' + lang;
  } else {
    url = url + '?lang=' + lang;
  }

  let loginId = window.sessionStorage.getItem('loginId');
  let source = url + '&&' + loginId;
  const newOptions = { ...option };
  if (
    newOptions.method &&
    (newOptions.method.toUpperCase() === 'POST' ||
      newOptions.method.toUpperCase() === 'PUT' ||
      newOptions.method.toUpperCase() === 'DELETE')
  ) {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...newOptions.headers,
        iwmsJwt: window.sessionStorage['loginKey'],
      };
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      // newOptions.body is FormData
      newOptions.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        ...newOptions.headers,
        iwmsJwt: window.sessionStorage['loginKey'],
      };
    }
  } else {
    newOptions.headers = {
      ...newOptions.headers,
      iwmsJwt: window.sessionStorage['loginKey'],
    };
  }

  if (newOptions.body) {
    source = source + '@@' + newOptions.body;
  }
  let sercet = encode(source);

  newOptions.headers = {
    ...newOptions.headers,
    iwmsSecret: sercet,
  };

  return request(
    proxy(url, newOptions ? newOptions.mock : undefined),
    newOptions,
    { signal },
  )
    .then(response => {
      // console.log(1, response);
      if (response && !response.success) {
        // checkStatus(response);
        message.error(response.message);
      }
      return response;
    })
    .catch(function(error) {
      // console.log(2, error, error.response);
      let e = error.response;

      if (!navigator.onLine) {
        message.error(intl.formatMessage({ id: '当前网络不可用' }));
        controller.abort();
        return {
          error: 'no network',
          success: false,
        };
      }
      if (e == 'timeout') {
        message.error(intl.formatMessage({ id: '请求超时' }));
        controller.abort();
        return {
          error: 'timeout',
          success: false,
        };
      } else {
        message.error(error.data.message);
        return error.data;
      }
    });
}

export function proxy(url, mock) {
  if (!mock) {
    url = url.replace(
      '/iwms-openapi',
      window.g_configs.API_SERVER + '/iwms-openapi',
    );
    url = url.replace(
      '/iwms-basic',
      window.g_configs.API_SERVER + '/iwms-basic',
    );
    url = url.replace(
      '/iwms-account',
      window.g_configs.API_SERVER + '/iwms-account',
    );
  }

  return url;
}
